import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { ProtocolService } from "../declarations/protocolService";
import { useProtocolService } from "../hooks/useProtocolService";
import { usePackage } from "../hooks/usePackage";
import { useDispatch } from "react-redux";
import { setFeeValue } from "../reducer/tourReducer";
import { previousDay } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";
import LocationFinder from "../components/common/LocationFinder";
import LocationInput from "../components/common/LocationInput";
import ProtocolLocationInput from "../components/common/ProtocolLocationInput";
import { ErrorSharp } from "@mui/icons-material";

const CreateProtocolPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { protocolService } = useProtocolService();
  const [loading, setLoading] = useState(false);
  const { calculateNetProfit, getPlatformFee } = usePackage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [highlightInput, setHighlightInput] = useState("");
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [locationData, setLocationData] = useState({
    value: "",
    city: "",
    country: "",
    latitude: 0,
    longitude: 0,
  });

  console.log("location", locationData);

  const [protocolServiceData, setProtocolServiceData] =
    useState<ProtocolService>({
      title: "",
      shortDescription: "",
      longDescription: "",
      servicesIncluded: [],
      priceSetting: "",
      protocolServicePackageType: "",
      protocolServiceType: "",
      groupPrice: null,
      groupSize: null,
      calculatedGroupPrice: null,
      adultPrice: null,
      infantPrice: null,
      totalAdults: null,
      totalSeniors: null,
      totalEuCitizens: null,
      totalStudents: null,
      totalMilitaries: null,
      totalInfants: null,
      seniorPrice: null,
      euCitizensPrice: null,
      studentPrice: null,
      militaryPrice: null,
      calculatedAdultPrice: null,
      calculatedSeniorPrice: null,
      calculatedMilitaryPrice: null,
      calculatedStudentPrice: null,
      calculatedeuCitizensPrice: null,
      calculatedInfantPrice: null,
      city: "",
      country: "",
      latitude: null,
      longitude: null,
      highlight: [],
      startingDate: new Date().toISOString(),
    });

  const handleSelectLocation = (location: {
    city?: string;
    country?: string;
    latitude: number;
    longitude: number;
  }) => {
    setLocationData((prev) => ({
      ...prev,

      city: location.city || "",
      country: location.country || "",
      latitude: location.latitude,
      longitude: location.longitude,
    }));

    setProtocolServiceData((prev) => ({
      ...prev,

      city: location.city || "",
      country: location.country || "",
      latitude: location.latitude,
      longitude: location.longitude,
    }));
  };

  const validate = (): boolean => {
    const newErrors: Record<string, string> = {};
    if (currentPage === 1) {
      if (!protocolServiceData.title) {
        newErrors.title = "Protocol Service Title is required";
      }
      if (!protocolServiceData.shortDescription) {
        newErrors.shortDescription = "Short description is required";
      }
      if (!protocolServiceData.longDescription) {
        newErrors.longDescription = "Full description is required";
      }
      if (!locationData.city) {
        newErrors.city = "City is required";
      }
      if (!locationData.country) {
        newErrors.country = "Country is required";
      }
      // if (protocolServiceData?.highlight?.length !== 0){
      //   newErrors.highlight = "Highlight should not be empty"
      // }
    }

    if (currentPage === 2) {
      if (!protocolServiceData.priceSetting) {
        newErrors.priceSetting = "Please select a pricing option.";
      }

      if (protocolServiceData.priceSetting === "fixed") {
        if (!protocolServiceData.groupPrice)
          newErrors.groupPrice = "Group price is required.";
        if (!protocolServiceData.groupSize)
          newErrors.groupSize = "Group size is required.";
      }

      if (protocolServiceData.priceSetting === "age_group") {
        if (!protocolServiceData.adultPrice) {
          newErrors.adultPrice = "Adult Price is required";
        }
        if (!protocolServiceData.seniorPrice) {
          newErrors.seniorPrice = "Senior Price is required";
        }
        if (!protocolServiceData.euCitizensPrice) {
          newErrors.euCitizensPrice = "EU Citizen Price is required";
        }
        if (!protocolServiceData.studentPrice) {
          newErrors.studentPrice = "Student Price is required";
        }
        if (!protocolServiceData.militaryPrice) {
          newErrors.militaryPrice = "Military Price is required";
        }
        if (!protocolServiceData.infantPrice) {
          newErrors.infantPrice = "Infant Price is required";
        }
        if (!protocolServiceData.totalAdults) {
          newErrors.totalAdults = "Total Adults is required";
        }
        if (!protocolServiceData.totalSeniors) {
          newErrors.totalSeniors = "Total Seniors is required";
        }
        if (!protocolServiceData.totalEuCitizens) {
          newErrors.totalEuCitizens = "Total EU Citizens is required";
        }
        if (!protocolServiceData.totalStudents) {
          newErrors.totalStudents = "Total Students is required";
        }
        if (!protocolServiceData.totalMilitaries) {
          newErrors.totalMilitaries = "Total Militaries is required";
        }
        if (!protocolServiceData.totalInfants) {
          newErrors.totalInfants = "Total Infants is required";
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    const isValid = validate();
    if (isValid) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleBack = () => setCurrentPage(currentPage - 1);

  useEffect(() => {
    const fetchPlatformFee = async () => {
      try {
        setLoading(true);
        const response = await getPlatformFee({ setLoading });
        setLoading(false);
        dispatch(setFeeValue(response.value));
      } catch (error) {
        console.error("Failed to fetch platform fee:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlatformFee();
  }, []);

  const calculateNetProfits = (price: number | null) => {
    if (!price || isNaN(price)) return 0;
    const priceData = Math.abs(price);
    const calculatePrice = calculateNetProfit(priceData);
    return Math.abs(calculatePrice);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    const numericFields = [
      "adultPrice",
      "seniorPrice",
      "euCitizensPrice",
      "studentPrice",
      "militaryPrice",
      "infantPrice",
      "groupPrice",
    ];

    setProtocolServiceData((prevData) => {
      const isNumericField = numericFields.includes(name);
      const parsedValue = isNumericField
        ? Math.abs(parseInt(value)) || null
        : value;

      const updatedData = {
        ...prevData,
        [name]: parsedValue,
      };

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });

      if (name === "adultPrice") {
        updatedData.calculatedAdultPrice = calculateNetProfits(parsedValue);
      }
      if (name === "seniorPrice") {
        updatedData.calculatedSeniorPrice = calculateNetProfits(parsedValue);
      }
      if (name === "euCitizensPrice") {
        updatedData.calculatedeuCitizensPrice =
          calculateNetProfits(parsedValue);
      }
      if (name === "studentPrice") {
        updatedData.calculatedStudentPrice = calculateNetProfits(parsedValue);
      }
      if (name === "militaryPrice") {
        updatedData.calculatedMilitaryPrice = calculateNetProfits(parsedValue);
      }
      if (name === "infantPrice") {
        updatedData.calculatedInfantPrice = calculateNetProfits(parsedValue);
      }

      if (name === "groupPrice") {
        updatedData.calculatedGroupPrice = calculateNetProfits(parsedValue);
      }

      return updatedData;
    });
  };

  // Handle checkboxes
  const handleCheckboxChange = (service: any) => {
    setProtocolServiceData((prev: any) => {
      const updatedServices = prev.servicesIncluded.includes(service)
        ? prev.servicesIncluded.filter((s: any) => s !== service)
        : [...prev.servicesIncluded, service];
      return { ...prev, servicesIncluded: updatedServices };
    });
  };

  const addHighlight = () => {
    if (highlightInput.trim()) {
      setProtocolServiceData((prev: any) => ({
        ...prev,
        highlight: [...prev?.highlight, highlightInput.trim()],
      }));
      setHighlightInput("");
    }
  };

  const removeHighlight = (index: any) => {
    setProtocolServiceData((prev) => ({
      ...prev,
      highlight: prev?.highlight?.filter((_, i) => i !== index),
    }));
  };

  const handleSumbit = async () => {
    setLoading(true);
    const response = await protocolService(protocolServiceData);
    setLoading(false);

    if (response?.status === 201) {
      navigate(Paths.welcome);
    }
    console.log("resp", response);
  };
  console.log("protocolservice", protocolServiceData);
  return (
    <div>
      <Navbar />
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-semibold mt-10 mb-6 px-4">
          Create a protocol service
        </h1>
        <div className="bg-gray-50 p-4 lg:p-8 shadow-md my-5 lg:my-10">
          <div className="w-full bg-white p-4 lg:p-8">
            {currentPage === 1 && (
              <div>
                <h2 className="text-2xl font-semibold mb-6">
                  Create a protocol service
                </h2>
                <form className="space-y-6">
                  {/* Protocol Service Title */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Protocol Service Title
                    </label>
                    <p className="text-xs text-gray-500 mb-2">
                      This is for your own use, customers won’t see this.
                    </p>
                    <input
                      name="title"
                      type="text"
                      placeholder="e.g Executive protocol service"
                      value={protocolServiceData.title}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {errors.title && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.title}
                      </p>
                    )}
                  </div>

                  {/* Short Description */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Add a short description
                    </label>
                    <p className="text-xs text-gray-500 mb-2">
                      Provide little details about what the customer will see
                      and experience during the activity.
                    </p>
                    <input
                      name="shortDescription"
                      type="text"
                      placeholder="Enter details"
                      value={protocolServiceData.shortDescription}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {errors.shortDescription && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.shortDescription}
                      </p>
                    )}
                  </div>

                  {/* Full Description */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Add a full description
                    </label>
                    <p className="text-xs text-gray-500 mb-2">
                      Provide all the details about the activity in the correct
                      order.
                    </p>
                    <textarea
                      name="longDescription"
                      cols={30}
                      rows={7}
                      placeholder="Enter your details"
                      value={protocolServiceData.longDescription}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    ></textarea>
                    {errors.longDescription && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.longDescription}
                      </p>
                    )}
                  </div>

                  {/* City and Country */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        City
                      </label>

                      <div className="w-full">
                        <ProtocolLocationInput
                          setValue={() => locationData.city}
                          placeholder="Enter a city"
                          onSelectLocation={handleSelectLocation}
                        />
                      </div>
                      {errors.locationCity && (
                        <p className="text-red-50 text-xs mt-1">
                          {errors.locationCity}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Country
                      </label>

                      <div className="w-full">
                        <input
                          type="text"
                          value={locationData.country}
                          readOnly
                          className="border border-gray-300 p-3 w-full"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Included Services */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Included Services
                    </label>
                    <div className="grid grid-cols-2 md:grid-cols-6 gap-x-12">
                      {[
                        "Service 1",
                        "Service 2",
                        "Service 3",
                        "Service 4",
                        "Service 5",
                      ].map((service) => (
                        <label
                          key={service}
                          className="flex items-center space-x-2"
                        >
                          <input
                            type="checkbox"
                            checked={protocolServiceData?.servicesIncluded?.includes(
                              service
                            )}
                            onChange={() => handleCheckboxChange(service)}
                            className="h-4 w-4 text-blue-500"
                          />
                          <span>{service}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Service Package
                      </label>
                      <select
                        name="protocolServicePackageType"
                        value={protocolServiceData.protocolServicePackageType}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      >
                        {" "}
                        <option value="">Please select...</option>
                        <option value="hotel">hotel</option>
                        <option value="tour">tour</option>
                        <option value="flight">flight</option>
                        <option value="activity">activity</option>
                        <option value="event">event</option>
                        <option value="place">place</option>
                        <option value="all">all</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Protocol Service Type
                      </label>
                      <select
                        name="protocolServiceType"
                        value={protocolServiceData.protocolServiceType}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      >
                        <option value="">Please select...</option>
                        <option value="local">local</option>
                        <option value="international">international</option>
                        <option value="both">both</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Highlights
                    </label>
                    <div className="flex items-center space-x-2 mb-2">
                      <input
                        type="text"
                        placeholder="e.g Executive protocol service"
                        value={highlightInput}
                        onChange={(e) => setHighlightInput(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      />

                      <button
                        type="button"
                        onClick={addHighlight}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                      >
                        Add
                      </button>
                    </div>

                    <ul>
                      {protocolServiceData?.highlight?.map(
                        (highlight, index) => (
                          <li
                            key={index}
                            className="flex  justify-between items-center p-2 rounded mb-2 border border-blue-600 "
                          >
                            {highlight}
                            <button
                              onClick={() => removeHighlight(index)}
                              className="text-red-500"
                            >
                              remove
                            </button>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                  {errors.highlight && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.highlight}
                    </p>
                  )}

                  {/* Buttons */}
                  <div className="flex justify-end space-x-4">
                    <button
                      type="button"
                      className="px-6 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => handleNext()}
                      className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                    >
                      Next
                    </button>
                  </div>
                </form>
              </div>
            )}

            {currentPage === 2 && (
              <div>
                <h1 className="text-2xl font-semibold mb-6">
                  Protocol Service
                </h1>
                <form className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Price Setting
                    </label>
                    <select
                      className="w-full px-4 py-2 border rounded-md "
                      name="priceSetting"
                      value={protocolServiceData.priceSetting}
                      onChange={handleInputChange}
                    >
                      <option value="">Please Select...</option>
                      <option value="fixed">Price Indiviual</option>
                      <option value="age_group">age group</option>
                    </select>
                    {errors.priceSetting && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.priceSetting}
                      </p>
                    )}
                  </div>

                  {protocolServiceData.priceSetting === "fixed" && (
                    <div className="flex  gap-5">
                      <div>
                        <label className="mb-2">Group Price</label>
                        <input
                          name="groupPrice"
                          placeholder=""
                          value={Number(protocolServiceData?.groupPrice) || ""}
                          className={`w-full px-4 py-2 border rounded-md ${
                            errors.groupPrice && "border-red-500"
                          }`}
                          onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: e.target.name,
                                value: parseInt(e.target.value) || 0,
                              },
                            })
                          }
                        />
                        {errors.groupPrice && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.groupPrice}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="mb-2">Group Size</label>
                        <input
                          name="groupSize"
                          placeholder=""
                          value={Number(protocolServiceData?.groupSize) || ""}
                          className={`w-full px-4 py-2 border rounded-md ${
                            errors.groupSize && "border-red-500"
                          }`}
                          onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: e.target.name,
                                value: parseInt(e.target.value) || 0,
                              },
                            })
                          }
                        />
                        {errors.groupSize && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.groupSize}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="mb-2">Calculated Group Price</label>
                        <input
                          name="calculatedGroupPrice"
                          value={
                            protocolServiceData?.calculatedGroupPrice || ""
                          }
                          readOnly
                          className="w-full px-4 py-2 border rounded-md bg-gray-50"
                        />
                      </div>
                    </div>
                  )}
                  {protocolServiceData.priceSetting === "age_group" && (
                    <div>
                      <div>
                        <h2 className="font-medium text-gray-800 my-5">
                          Prices (per person)
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <label className="mb-2">Adult Price</label>
                            <input
                              name="adultPrice"
                              placeholder=""
                              value={
                                Number(protocolServiceData?.adultPrice) || ""
                              }
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.adultPrice && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.adultPrice && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.adultPrice}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">Senior Price</label>
                            <input
                              name="seniorPrice"
                              value={
                                Number(protocolServiceData?.seniorPrice) || ""
                              }
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.seniorPrice && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.seniorPrice && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.seniorPrice}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">EU Citizen Price</label>
                            <input
                              name="euCitizensPrice"
                              placeholder=""
                              value={
                                Number(protocolServiceData?.euCitizensPrice) ||
                                ""
                              }
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.euCitizensPrice && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.seniorPrice && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.euCitizensPrice}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">Student Price</label>
                            <input
                              name="studentPrice"
                              placeholder=""
                              value={
                                Number(protocolServiceData?.studentPrice) || ""
                              }
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.studentPrice && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.seniorPrice && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.seniorPrice}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">Military Price</label>
                            <input
                              name="militaryPrice"
                              placeholder=""
                              value={
                                Number(protocolServiceData?.militaryPrice) || ""
                              }
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.militaryPrice && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.seniorPrice && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.seniorPrice}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">Infant Price</label>
                            <input
                              name="infantPrice"
                              placeholder=""
                              value={
                                Number(protocolServiceData?.infantPrice) || ""
                              }
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.infantPrice && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.infantPrice && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.infantPrice}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div>
                        <h2 className="font-medium text-gray-800 my-5">
                          Calculated Prices (per person)
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <label className="mb-2">Adult Price</label>
                            <input
                              name="calculatedAdultPrice"
                              value={
                                protocolServiceData?.calculatedAdultPrice || ""
                              }
                              readOnly
                              className="w-full px-4 py-2 border rounded-md bg-gray-50"
                            />
                          </div>

                          <div>
                            <label className="mb-2">Senior Price</label>
                            <input
                              name="calculatedSeniorPrice"
                              value={
                                protocolServiceData?.calculatedSeniorPrice || ""
                              }
                              readOnly
                              className="w-full px-4 py-2 border rounded-md bg-gray-50"
                            />
                          </div>

                          <div>
                            <label className="mb-2">Eu Citzen Price</label>
                            <input
                              name="calculatedeuCitizensPrice"
                              value={
                                protocolServiceData?.calculatedeuCitizensPrice ||
                                ""
                              }
                              readOnly
                              className="w-full px-4 py-2 border rounded-md bg-gray-50"
                            />
                          </div>
                          <div>
                            <label className="mb-2">Student Price</label>
                            <input
                              name="calculatedStudentPrice"
                              placeholder=""
                              value={
                                protocolServiceData?.calculatedStudentPrice ||
                                ""
                              }
                              readOnly
                              className="w-full px-4 py-2 border rounded-md bg-gray-50"
                            />
                          </div>
                          <div>
                            <label className="mb-2">Military Price</label>
                            <input
                              name="calculatedMilitaryPrice"
                              value={
                                protocolServiceData?.calculatedMilitaryPrice ||
                                ""
                              }
                              readOnly
                              className="w-full px-4 py-2 border rounded-md bg-gray-50"
                            />
                          </div>
                          <div>
                            <label className="mb-2">infant Price</label>
                            <input
                              name="calculatedInfantPrice"
                              value={
                                protocolServiceData?.calculatedInfantPrice || ""
                              }
                              readOnly
                              className="w-full px-4 py-2 border rounded-md bg-gray-50"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Total Travelers */}
                      <div>
                        <h2 className="font-medium text-gray-800 my-5">
                          Total Travelers
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <label className="mb-2">Total Adult </label>
                            <input
                              name="totalAdults"
                              value={protocolServiceData?.totalAdults || ""}
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.totalAdults && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.totalAdults && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.totalAdults}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">Total Seniors</label>
                            <input
                              name="totalSeniors"
                              value={protocolServiceData?.totalSeniors || ""}
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.totalSeniors && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.totalSeniors && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.totalSeniors}
                              </p>
                            )}
                          </div>

                          <div>
                            <label className="mb-2">Total Eu Citzen </label>
                            <input
                              name="totalEuCitizens"
                              value={protocolServiceData?.totalEuCitizens || ""}
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.totalEuCitizens && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.totalEuCitizens && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.totalEuCitizens}
                              </p>
                            )}
                          </div>
                          <div>
                            <label className="mb-2">Total Student </label>
                            <input
                              name="totalStudents"
                              value={protocolServiceData?.totalStudents || ""}
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.totalStudents && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.totalStudents && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.totalStudents}
                              </p>
                            )}
                          </div>
                          <div>
                            <label className="mb-2">Total Military </label>
                            <input
                              name="totalMilitaries"
                              value={protocolServiceData?.totalMilitaries || ""}
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.totalMilitaries && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.totalMilitaries && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.totalMilitaries}
                              </p>
                            )}
                          </div>
                          <div>
                            <label className="mb-2">Total infant </label>
                            <input
                              name="totalInfants"
                              value={protocolServiceData?.totalInfants || ""}
                              className={`w-full px-4 py-2 border rounded-md ${
                                errors.totalInfants && "border-red-500"
                              }`}
                              onChange={(e) =>
                                handleInputChange({
                                  target: {
                                    name: e.target.name,
                                    value: parseInt(e.target.value) || 0,
                                  },
                                })
                              }
                            />
                            {errors.totalInfants && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors.totalInfants}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex justify-end gap-5">
                    <button
                      type="button"
                      onClick={handleBack}
                      className="px-6 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100"
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      onClick={() => handleNext()}
                      className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                    >
                      Preview
                    </button>
                  </div>
                </form>
              </div>
            )}

            {currentPage === 3 && (
              <div className="max-w-5xl mx-auto p-6">
                {/* Title Section */}
                <h2 className="text-2xl font-bold text-gray-800 mb-6">
                  Protocol Service Preview
                </h2>

                {/* General Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  {[
                    { label: "Title", value: protocolServiceData.title },
                    {
                      label: "Short Description",
                      value: protocolServiceData.shortDescription,
                    },
                    {
                      label: "Long Description",
                      value: protocolServiceData.longDescription,
                      fullWidth: true,
                    },
                    { label: "City", value: protocolServiceData.city },
                    { label: "Country", value: protocolServiceData.country },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className={`${item.fullWidth ? "col-span-2" : ""}`}
                    >
                      <h3 className="text-lg font-semibold text-gray-700">
                        {item.label}
                      </h3>
                      <p className="text-gray-600">{item.value || "N/A"}</p>
                    </div>
                  ))}
                </div>

                {/* Services Included */}
                <div className="mb-8">
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">
                    Services Included
                  </h3>
                  {protocolServiceData?.servicesIncluded?.length ? (
                    <ul className="list-disc list-inside text-gray-600">
                      {protocolServiceData.servicesIncluded.map(
                        (service, index) => (
                          <li key={index}>{service}</li>
                        )
                      )}
                    </ul>
                  ) : (
                    <p className="text-gray-600">No services included.</p>
                  )}
                </div>

                {/* Highlights */}
                <div className="mb-8">
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">
                    Highlights
                  </h3>
                  {protocolServiceData?.highlight?.length ? (
                    <div className="flex flex-wrap gap-2">
                      {protocolServiceData.highlight.map((highlight, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium"
                        >
                          {highlight}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-600">No highlights available.</p>
                  )}
                </div>

                {protocolServiceData.priceSetting == "fixed" && (
                  <div>
                    <div className="mb-8">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">
                        Prices Detail
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {[
                          {
                            label: "Group Price",
                            value: protocolServiceData.groupPrice,
                          },

                          {
                            label: "Group Size",
                            value: protocolServiceData.groupSize,
                          },
                          {
                            label: "Calculated Group Price",
                            value: protocolServiceData.calculatedGroupPrice,
                          },
                        ].map((item, index) => (
                          <div
                            key={index}
                            className="p-4 bg-gray-50 rounded-lg border"
                          >
                            <h4 className="text-sm font-medium text-gray-600">
                              {item.label}
                            </h4>
                            <p className="text-lg font-bold text-gray-800">
                              {item.value !== null ? `$${item.value}` : "N/A"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {protocolServiceData.priceSetting === "age_group" && (
                  <div>
                    <div className="mb-8">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">
                        Prices Detail
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {[
                          {
                            label: "Adult Price",
                            value: protocolServiceData.adultPrice,
                          },
                          {
                            label: "Senior Price",
                            value: protocolServiceData.seniorPrice,
                          },
                          {
                            label: "EU Citizens Price",
                            value: protocolServiceData.euCitizensPrice,
                          },
                          {
                            label: "Student Price",
                            value: protocolServiceData.studentPrice,
                          },
                          {
                            label: "Military Price",
                            value: protocolServiceData.militaryPrice,
                          },
                          {
                            label: "Infant Price",
                            value: protocolServiceData.infantPrice,
                          },
                        ].map((item, index) => (
                          <div
                            key={index}
                            className="p-4 bg-gray-50 rounded-lg border"
                          >
                            <h4 className="text-sm font-medium text-gray-600">
                              {item.label}
                            </h4>
                            <p className="text-lg font-bold text-gray-800">
                              {item.value !== null ? `$${item.value}` : "N/A"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-8">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">
                        Calculated Prices
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 ">
                        {[
                          {
                            label: "Calculated Adult Price",
                            value: protocolServiceData.calculatedAdultPrice,
                          },
                          {
                            label: "Calculated Senior Price",
                            value: protocolServiceData.calculatedSeniorPrice,
                          },
                          {
                            label: "Calculated Student Price",
                            value: protocolServiceData.calculatedStudentPrice,
                          },
                          {
                            label: "Calculated Military Price",
                            value: protocolServiceData.calculatedMilitaryPrice,
                          },
                          {
                            label: "Calculated EU Citizen Price",
                            value:
                              protocolServiceData.calculatedeuCitizensPrice,
                          },
                          {
                            label: "Calculated Infant Price",
                            value: protocolServiceData.calculatedInfantPrice,
                          },
                        ].map((item, index) => (
                          <div
                            key={index}
                            className="p-4 bg-gray-50 rounded-lg border"
                          >
                            <h4 className="text-sm font-medium text-gray-600">
                              {item.label}
                            </h4>
                            <p className="text-lg font-bold text-gray-800">
                              {item.value !== null ? `$${item.value}` : "N/A"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Total Price Section */}
                    <div className="mb-8">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">
                        Total Price
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {[
                          {
                            label: "Total Adults",
                            value: protocolServiceData.totalAdults,
                          },
                          {
                            label: "Total Seniors",
                            value: protocolServiceData.totalSeniors,
                          },
                          {
                            label: "Total Students",
                            value: protocolServiceData.totalStudents,
                          },
                          {
                            label: "Total Military",
                            value: protocolServiceData.totalMilitaries,
                          },
                          {
                            label: "Total EU Citizens",
                            value: protocolServiceData.totalEuCitizens,
                          },
                          {
                            label: "Total Infants",
                            value: protocolServiceData.totalInfants,
                          },
                        ].map((item, index) => (
                          <div
                            key={index}
                            className="p-4 bg-gray-50 rounded-lg border"
                          >
                            <h4 className="text-sm font-medium text-gray-600">
                              {item.label}
                            </h4>
                            <p className="text-lg font-bold text-gray-800">
                              {item.value !== null ? item.value : "N/A"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Navigation Buttons */}
                <div className="flex justify-end gap-4 mt-12">
                  <button
                    type="button"
                    onClick={() => setCurrentPage(1)}
                    className="px-6 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100 transition"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    onClick={handleSumbit}
                    className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                  >
                    {loading ? "Please Wait..." : "Submit"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProtocolPage;
